import React from 'react';
import Link from 'next/link';

const Login_ask_to_join: React.FC = () => {
  return (
    <div className="mem-wrapper">
      <h2>회원가입</h2>
      <div className="login">
        <p style={{ textAlign: 'center', marginBottom: '20px' }}>
          로컬스티치 회원가입을 진행합니다.
        </p>
        <fieldset>
          <legend>회원가입</legend>
          <div className="btn">
            <Link href="/auth/join">
              <a>회원가입 진행</a>
            </Link>
          </div>
        </fieldset>
      </div>
    </div>
  );
};

export default Login_ask_to_join;
